import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  selectedUser: string | null; // Changed from Account | null
  isExpired: boolean;
  isAccountBlocked: boolean;
  expiryDate: string | null;
  daysRemaining: number | null;
  planName: string | null;
  // True when the user has already consumed their free trial. Used by the
  // Subscriptions page to suppress trial-promo UI for returning customers.
  hasTrialed: boolean;
  subscriptionCategories: string[];
}

const initialState: UserState = {
  selectedUser: null,
  isExpired: false,
  isAccountBlocked: false,
  expiryDate: null,
  daysRemaining: null,
  planName: null,
  hasTrialed: false,
  subscriptionCategories: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSelectedUser(state, action: PayloadAction<string | null>) {
      state.selectedUser = action.payload;
    },
    setExpiry(state, action: PayloadAction<boolean>) {
      state.isExpired = action.payload;
    },
    setAccountBlocked(state, action: PayloadAction<boolean>) {
      state.isAccountBlocked = action.payload;
    },
    setExpiryDate(state, action: PayloadAction<string | null>) {
      state.expiryDate = action.payload;
    },
    setDaysRemaining(state, action: PayloadAction<number | null>) {
      state.daysRemaining = action.payload;
    },
    setPlanName(state, action: PayloadAction<string | null>) {
      state.planName = action.payload;
    },
    setHasTrialed(state, action: PayloadAction<boolean>) {
      state.hasTrialed = action.payload;
    },
    setSubscriptionCategories(state, action: PayloadAction<string[]>) {
      state.subscriptionCategories = action.payload;
    },
    logout(state) {
      state.selectedUser = null;
      state.isExpired = false;
      state.isAccountBlocked = false;
      state.expiryDate = null;
      state.daysRemaining = null;
      state.planName = null;
      state.hasTrialed = false;
      state.subscriptionCategories = [];
    },
  },
});

export const { setSelectedUser, setExpiry, setAccountBlocked, setExpiryDate, setDaysRemaining, setPlanName, setHasTrialed, setSubscriptionCategories, logout } = userSlice.actions;
export default userSlice.reducer;